import React from "react";
import { useSearchParams } from "react-router-dom";
import { Waves, Gauge } from "lucide-react";
import PoolLog from "@/pages/PoolLog";
import MaintenanceUtilities from "@/pages/MaintenanceUtilities";

const TABS = [{ k: "pools", l: "Πισίνες", icon: Waves }, { k: "utilities", l: "Νερό & Ρεύμα", icon: Gauge }];

export default function Readings() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "pools";
  return (
    <div className="space-y-6" data-testid="readings-page">
      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button key={t.k} data-testid={`readings-tab-${t.k}`} onClick={() => setParams({ tab: t.k })}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold border ${tab === t.k ? "bg-[#45423C] text-white border-[#45423C]" : "border-[#E3DED4] text-[#6F6A60] bg-white"}`}>
            <t.icon className="h-4 w-4" /> {t.l}
          </button>
        ))}
      </div>
      {tab === "pools" ? <PoolLog /> : <MaintenanceUtilities />}
    </div>
  );
}
